
<div
  class="requirement cursor-pointer rounded-xl border-2 border-dashed border-transparent focus-within:border-brand-contrast focus-within:border-dashed p-4 active:border-transparent"
  :class="{ selected: userHasSelected }"
  @focusin="setIsFocused(true)"
  @focusout="setIsFocused(false)"
  @mouseenter="setIsHovered(true)"
  @mouseleave="setIsHovered(false)"
>
  <div v-if="!isButton">
    <input :id="value" type="checkbox" class="sr-only" :value="value" :checked="userHasSelected" @change="updateSelections" />
    <label :for="value" class="flex flex-col items-center centered cursor-pointer" @click="setClicked(true)">
      <div aria-hidden="true">
        <slot name="graphic" />
      </div>
      <span class="text-subtitle my-8 cursor-pointer" :class="labelClasses">
        <slot />
      </span>
    </label>
  </div>
  <button
    v-else
    :id="value"
    :value="value"
    type="button"
    class="outline-none cursor-pointer flex flex-col items-center centered m-auto"
    @click="buttonClicked"
    @mousedown="setClicked(true)"
    @mouseup="setClicked(true)"
  >
    <div aria-hidden="true" class="inline-block">
      <slot name="graphic" />
    </div>
    <p class="text-subtitle my-8 cursor-pointer" :class="labelClasses">
      <slot />
    </p>
  </button>
</div>
